<template>
  <collapsible-section class='_pt0 _pb0' :collapsed='false' :collapsible="false">
    <template #headerText>
      <p class='color-leaf'>Payment History</p>
    </template>
    <template #headerActions>
      <column-picker :headers="headers" @updateHeaders="updateHeaders"/>
        <button class="btn white --sm _mrxs forcewidth" @click="toggleFilters">
          <template v-if="!showFilters">
            Show Filters
          </template>
          <template v-else>
            Hide Filters
          </template>
        </button>
    </template>
    <template #collapsibleSection>
      <async-loader v-if='invoicePaymentHistoryLoading'/>
      <div v-else container>
        <div row>
          <app-advanced-table
            class='_p0'
            sort-by="paidDate"
            :descending="true"
            :headers="headers"
            noDataText="Payment history not found."
            :items="computedInvoicePaymentHistory"
            @cellClicked="goToInvoice"
            :custom-sort="tableSorter"
          >
            <template #headers='{ headers, pagination, changeSort }' >
              <tr tabindex="0">
                <th
                  v-for="header in headers"
                  :key="header.text"
                  tabindex="0"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                >
                  <div @click="changeSort(header.value)">
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </div>

                  <app-placeholder-input
                    v-if="showFilters"
                    class="-tiny"
                    :value="getFilterValue(header.value)"
                    @input="setFilterValue(header.value, $event)"
                    valueKey="'filter_' + header.value`"
                    label=""
                    />
                </th>
              </tr>
            </template>
          </app-advanced-table>
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import ColumnPicker from '@molecules/ColumnPicker'
  import CollapsibleSection from '@sections/CollapsibleSection'
  import AsyncLoader from '@molecules/AsyncLoader'
  import AppAdvancedTable from '@organisms/AdvancedTable'
  import billing from '@mixins/billing'
  import formattable from '@mixins/formattable'
  import tableSorter from '@mixins/tableSorter'
  import AppPlaceholderInput from '@atoms/PlaceholderInput'

  export default {
    mixins: [billing, formattable, tableSorter],
    components: {
      ColumnPicker,
      CollapsibleSection,
      AppAdvancedTable,
      AsyncLoader,
      AppPlaceholderInput
    },
    data () {
      return {
        filters: {},
        showFilters: false,
        headers: [
          { text: 'Payment Date', value: 'paidDate' },
          { text: 'Invoice Type', value: 'invoiceTypeDescription' },
          { text: 'Group', value: 'group', visible: true },
          { text: 'Subgroup', value: 'subGroup', visible: true },
          { text: 'Invoice Date', value: 'displayInvoiceDate' },
          { text: 'Invoice No.', value: 'invoiceNumber' },
          { text: 'Invoice Amount', value: 'displayInvoiceAmount' },
          { text: 'Payment Type', value: 'paymentTypeDescription' },
          { text: 'Payment Method', value: 'paymentMethod' },
          { text: 'Payment Cycle', value: 'paymentCycleDescription' },
          { text: 'Transaction Amount', value: 'displayPaidAmount' },
          { text: 'User Id', value: 'paidUser' }
        ]
      }
    },
    methods: {
      toggleFilters() {
        this.showFilters = !this.showFilters
        if (!this.showFilters) {
          Object.keys(this.filters).forEach(filterKey => {
            this.filters[filterKey] = ''
          })
        }
      },
      getFilterValue(key) {
        return this.filters[key]
      },
      setFilterValue(key, value) {
        this.$set(this.filters, key, value)
      },
      updateHeaders (headers) {
        this.headers = headers
      },
      goToInvoice (invoice) {
        this.$router.push({
          name: 'invoice-details',
          params: {
            invoiceNumber: invoice.invoiceNumber
          }
        })
      }
    },
    computed: {
      computedIndividualInvoicePaymentHistory() {
        return this.invoicePaymentHistory.map(paymentHistory => {
          return {
            ...paymentHistory
          }
        })
      },
      computedInvoicePaymentHistory() {
        if (!this.showFilters) {
          this.$emit('updateFilteredInvoicePaymentHistory', this.computedIndividualInvoicePaymentHistory)
          return this.computedIndividualInvoicePaymentHistory
        }

        let filterdInvoicePaymentHistory = [ ...this.computedIndividualInvoicePaymentHistory ]
        Object.keys(this.filters).forEach((key) => {
          var filter = this.filters[key]
          filterdInvoicePaymentHistory = filterdInvoicePaymentHistory.filter(paymentHistory => {
            if (paymentHistory[key] === undefined) {
              console.warn(`Key ${key} is not found on paymentHistory`)
              return true
            }

            return paymentHistory[key].toLowerCase().includes(filter.toLowerCase())
          })
        })
        this.$emit('updateFilteredInvoicePaymentHistory', filterdInvoicePaymentHistory)
        return filterdInvoicePaymentHistory
      }
    }
  }
</script>
